import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 73 — "Filipino virtual assistant + cost savings + business process
 * automation" cluster service links.
 *
 * Each Batch 73 article routes its primary commercial link to the automation
 * service page that matches its angle (Zapier/Make for cost-savings & BPA,
 * n8n for hire-to-automate, HubSpot for ROI tracking, CRM for true-cost). The
 * answer-first leads in batch73Content.ts embed the link directly, but the
 * lead-swap idempotency guard can drop the lead when the Quick Answer
 * duplicates the lead text. This map is the RELIABLE fallback:
 * `injectBatchServiceLink` (batchContentOptimizer.ts) wraps the first in-body
 * occurrence of each anchor phrase in the service-page link, so the contextual
 * service link always renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH73_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "filipino-virtual-assistant-cost-savings": {
    url: "/zapier-make-automation-expert",
    anchor: /VA who works by hand saves the hourly rate but not the process/i,
    label: "hire a Zapier and Make automation expert",
  },
  "hire-filipino-virtual-assistant-automate-business-processes": {
    url: "/n8n-workflow-developer",
    anchor:
      /VA who works the inbox by hand is a hire the team outgrows at the first volume spike/i,
    label: "hire an n8n workflow developer",
  },
  "filipino-virtual-assistant-roi": {
    url: "/hubspot-revops-architect",
    anchor:
      /VA who saves the hourly rate but not the process is a hire the team undercounts/i,
    label: "hire a HubSpot RevOps architect",
  },
  "true-cost-of-hiring-a-filipino-virtual-assistant": {
    url: "/CRM-revops-architect",
    anchor:
      /VA with no automation is a hire the team undercounts by the hours the process eats/i,
    label: "hire a CRM RevOps architect",
  },
  "filipino-virtual-assistant-business-process-automation": {
    url: "/zapier-make-automation-expert",
    anchor:
      /VA who works the inbox by hand is a hire the team outgrows at the first volume spike/i,
    label: "hire a Zapier and Make automation expert",
  },
};
